import styled from "styled-components";
import { Button } from "../ui";

export const ModalForm = ({
  children,
  showModal,
  setShowModal,
  title,
  handleSubmitRef,
  textButton,
  ...otherProps
}) => {
  // function handleModal() {
  //   setShowModal(false);
  // }

  return (
    <>
      {/* {showModal && (
        <Overlay {...otherProps}> */}
      <Container>
        {/* <Header>
              <div></div>
              <CloseBlueIcon onClick={() => handleModal()} />
            </Header> */}
        {/* <Title>{title}</Title> */}
        <FormContainer onSubmit={handleSubmitRef}>
          {children}
          {textButton && (
            <Button
              text={textButton}
              type="submit"
              style={{ margin: "10px auto 0 auto", display: "flex" }}
            />
          )}
        </FormContainer>
      </Container>
      {/* </Overlay>
      )} */}
    </>
  );
};

// const Overlay = styled.div`
//   width: 100%;
//   height: 100%;
//   position: fixed;
//   top: 0;
//   background-color: #9B9DA191;
//   z-index: 10;
//   overflow: hidden;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

const Container = styled.div`
  width: 600px;
  /* width: 600px;
  background-color: #fff;
  z-index: 11;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #dee2e6;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  color: var(--neutrals-charcoal);
  padding-bottom: 48px;
  max-height:90vh;
  overflow:scroll;
  & > form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  & > form > div {
    width: 100%;
    margin-bottom: 18px;
  } */
  @media only screen and (max-width: 640px) {
    width: 100%;
    padding: 0px 0px;
    & form {
      padding: 10px 0px;
    }
  }
`;

// const Header = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   width: 100%;
// `;

// const Title = styled.h2`
//   font-size: 24px;
//   font-weight: 700;
//   margin-bottom: 24px;
//   text-align: center;
// `;

const FormContainer = styled.form`
  padding: 0 48px;
`;
